import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { MoireMark } from "@/components/MoireLogo";
import { Swatch } from "@/components/ColorSwatch";

export default function ShareCard({ open, onOpenChange, data }) {
  if (!data) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-transparent border-0 shadow-none p-0 max-w-sm" data-testid="share-card">
        <DialogTitle className="sr-only">Your MOIRÉ match share card</DialogTitle>
        <div className="bg-[#0D0D0D] border border-[#C8A97E]/40 p-8 text-center relative overflow-hidden">
          <div className="flex justify-center mb-6"><MoireMark size={44} /></div>
          <div className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170]">My Match</div>
          <h3 className="font-serif text-4xl text-[#F5F2EA] mt-3">
            {data.baseColor} <span className="text-[#8A8170]">+</span> {data.matchColor}
          </h3>
          <div className="flex justify-center gap-3 my-6">
            <Swatch hex={data.baseHex} />
            <Swatch hex={data.matchHex} />
          </div>
          <div className="font-serif text-5xl text-[#C8A97E]">{Number(data.score).toFixed(1)}</div>
          <div className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170] mt-1">/ 10</div>
          {data.statusText && (
            <div className="font-serif text-xl text-[#F5F2EA] mt-4">{data.statusText}</div>
          )}
          <div className="gold-line my-6" />
          <div className="font-serif italic text-lg text-[#F5F2EA]">Dress Up. Don't Mess Up.</div>
          <div className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170] mt-3">moire.live</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
